var _symbol, _symbol2, _symbol3, _symbol4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpritemedalsRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "gold",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FCC861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2266 8.46484C15.2266 9.20443 14.9896 9.8112 14.5156 10.2852C14.0417 10.7539 13.3776 11.0534 12.5234 11.1836V11.2461C13.4922 11.3763 14.224 11.6758 14.7188 12.1445C15.2188 12.6133 15.4688 13.2253 15.4688 13.9805C15.4688 15.0482 15.0651 15.8815 14.2578 16.4805C13.4505 17.0742 12.3177 17.3711 10.8594 17.3711C9.48958 17.3711 8.38021 17.1654 7.53125 16.7539V15.4414C8.04688 15.6862 8.59896 15.8737 9.1875 16.0039C9.78125 16.1289 10.3333 16.1914 10.8438 16.1914C11.875 16.1914 12.651 16.0013 13.1719 15.6211C13.6979 15.2409 13.9609 14.694 13.9609 13.9805C13.9609 13.2982 13.6667 12.7826 13.0781 12.4336C12.4896 12.0794 11.612 11.9023 10.4453 11.9023H8.8125V10.6992H10.3594C11.4896 10.6992 12.3333 10.5117 12.8906 10.1367C13.4531 9.75651 13.7344 9.24609 13.7344 8.60547C13.7344 8.05339 13.526 7.61849 13.1094 7.30078C12.6979 6.97786 12.1406 6.81641 11.4375 6.81641C10.8438 6.81641 10.3073 6.88672 9.82812 7.02734C9.35417 7.16797 8.83333 7.42318 8.26562 7.79297L7.57812 6.81641C8.67708 6.02474 9.96875 5.62891 11.4531 5.62891C12.625 5.62891 13.5469 5.88411 14.2188 6.39453C14.8906 6.90495 15.2266 7.59505 15.2266 8.46484Z",
    fill: "black"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "silver",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1484 6.89453C11.9193 6.89453 10.9531 7.30599 10.25 8.12891C9.54688 8.95182 9.19531 10.0768 9.19531 11.5039C9.19531 12.9779 9.53646 14.1159 10.2188 14.918C10.901 15.7148 11.8724 16.1133 13.1328 16.1133C13.9453 16.1133 14.8594 15.9622 15.875 15.6602V16.9102C15.3906 17.0872 14.9245 17.207 14.4766 17.2695C14.0286 17.3372 13.513 17.3711 12.9297 17.3711C11.2474 17.3711 9.95052 16.8607 9.03906 15.8398C8.13281 14.8138 7.67969 13.3633 7.67969 11.4883C7.67969 10.3112 7.89583 9.27995 8.32812 8.39453C8.76562 7.50911 9.39844 6.82682 10.2266 6.34766C11.0599 5.86849 12.0391 5.62891 13.1641 5.62891C14.3724 5.62891 15.4245 5.85286 16.3203 6.30078L15.7422 7.51953C14.8307 7.10286 13.9661 6.89453 13.1484 6.89453Z",
    fill: "black"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "bronze",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#DCB386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7344 13.8672C15.7344 14.9922 15.3958 15.8307 14.7188 16.3828C14.0417 16.9349 13.0052 17.2109 11.6094 17.2109H8.26562V5.78906H15.0469V7.05469H9.70312V10.6172H11.3984C12.8568 10.6172 13.9427 10.875 14.6562 11.3906C15.375 11.9062 15.7344 12.7318 15.7344 13.8672ZM9.70312 15.9766H11.4609C12.4401 15.9766 13.1484 15.8125 13.5859 15.4844C14.0286 15.151 14.25 14.612 14.25 13.8672C14.25 13.138 14.0208 12.6224 13.5625 12.3203C13.1042 12.0182 12.3255 11.8672 11.2266 11.8672H9.70312V15.9766Z",
    fill: "black"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "total",
    viewBox: "0 0 27 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#FCC861"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 6,
    r: 6,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 18,
    r: 6,
    fill: "#DCB386"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpritemedalsRu);
export default __webpack_public_path__ + "static/media/Spritemedals_ru.f2aa7ac8c30b43b13b2d3ef048f1ca56.svg";
export { ForwardRef as ReactComponent };